import axios from 'axios'

const url = process.env.REACT_APP_API_URL_USER

const authConfig = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
})

class AnnouncementService {
    active(unreadOnly = true) {
        return axios.get(`${url}/announcements/active`, {
            ...authConfig(),
            params: { unreadOnly }
        })
    }

    markRead(id) {
        return axios.post(`${url}/announcements/${id}/read`, {}, authConfig())
    }
}

export default new AnnouncementService()
